import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { AppConfig, AppConfigurationSchema } from './models'

export const appConfigQueryKey = ['remoteConfig'] as const

export type AppConfigQueryOptions<T> = Omit<
  UseQueryOptions<AppConfig, unknown, T, typeof appConfigQueryKey>,
  'queryKey' | 'queryFn'
>

async function fetchConfig() {
  const defaultRemoteConfigUrl =
    'https://businesses.api.vatominc.com/viewers/config?hostname=wallet.vatom.com'

  const res = await fetch(defaultRemoteConfigUrl)
  const data = await res.json()

  const validated = AppConfigurationSchema.safeParse(data)
  if (validated.success) {
    return validated.data
  } else {
    console.error('Invalid config response', validated.error)
    return data as AppConfig
  }
}

export const useAppConfig = <T = AppConfig>(options?: AppConfigQueryOptions<T>) => {
  const query = useQuery({
    queryKey: appConfigQueryKey,
    queryFn: fetchConfig,
    ...options
  })
  return query
}
